var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import throttle from 'lodash/throttle';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import * as reducerActions from './actions';
import * as localStorage from './localStorage';
import * as reducers from './reducers';
import getRootReducer from './reducers/root';
import * as sagas from './sagas';
var getCombinedReducers = function (reducersObj) {
    if (reducersObj === void 0) { reducersObj = {}; }
    var appReducer = combineReducers(reducersObj);
    return getRootReducer(appReducer);
};
var getRootSaga = function (sagasObj) {
    if (sagasObj === void 0) { sagasObj = {}; }
    return function rootSaga() {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, all(Object.keys(sagasObj).map(function (key) { return sagasObj[key](); }))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    };
};
var getStore = function (options) {
    var _a = options || {}, stateKey = _a.stateKey, saveStateKeys = _a.saveStateKeys, persistState = _a.persistState, initialState = _a.initialState, reducers = _a.reducers, sagas = _a.sagas, logger = _a.logger;
    if (!reducers)
        console.warn('[WARNING]: reducers not defined in redux store!');
    if (!sagas)
        console.warn('[WARNING]: sagas not defined in redux store!');
    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            trace: true,
            traceLimit: 25,
            maxAge: 100,
            predicate: function (state, action) {
                return [
                    'INSPECT_UNSUBS',
                    'API_CANCELLED',
                ].find(function (t) { return action.type === t; }) === undefined;
            },
        })
        : compose;
    var preloadedState = __assign(__assign({}, initialState), (persistState ? localStorage.loadState(stateKey) : undefined));
    var _logger = logger ? logger : { log: function () { } };
    var customLogger = function (store) { return function (next) { return function (action) {
        _logger.log("dispatch " + action.type, { action: action });
        var result = next(action);
        _logger.log('state', { store: store.getState() });
        return result;
    }; }; };
    var sagaMiddleware = createSagaMiddleware();
    var allMiddleware = logger
        ? [sagaMiddleware, customLogger]
        : [sagaMiddleware];
    var store = createStore(getCombinedReducers(reducers), preloadedState, composeEnhancers(applyMiddleware.apply(void 0, allMiddleware)));
    store.subscribe(throttle(function () {
        localStorage.saveState(localStorage.getSavedState(store.getState(), saveStateKeys), stateKey);
    }, 1000));
    sagaMiddleware.run(getRootSaga(sagas));
    return store;
};
var actions = __assign({}, reducerActions);
export { localStorage, reducers, sagas, actions, getCombinedReducers, getRootSaga, getStore, };
//# sourceMappingURL=index.js.map